// extracted by mini-css-extract-plugin
export default {"rating":"EvaluationRating_rating__kBPjj","answers":"EvaluationRating_answers__4miTG","notRated":"EvaluationRating_notRated__hCGOn"};